import React, { useEffect } from 'react';
import { useForm } from 'react-hook-form';
import Typography from '@mui/material/Typography';
import Grid2 from '@mui/material/Grid2';
import Paper from '@mui/material/Paper';
import {useSxStyles as classes} from "../styles/sxStyles";
import FormControl from "@mui/material/FormControl";
import FormLabel from "@mui/material/FormLabel";
import TextField from "@mui/material/TextField";
import {NumericFormat, PatternFormat} from "react-number-format";
import {LocalizationProvider} from "@mui/x-date-pickers/LocalizationProvider";
import {AdapterDateFns} from "@mui/x-date-pickers/AdapterDateFns";
import {DatePicker} from "@mui/x-date-pickers";
import Select from "@mui/material/Select";
import {statesLong} from "../config/utils";

const PaymentInfo = (props) => {
    const paymentInfo = props.paymentInfo;
    const amounts = props.amounts;
    const getProcessingFee = props.getProcessingFee;
    const clearValues = props.clearValues;
    const setEditAmt = props.setEditAmt;
    const { register, reset } = useForm();

    const handleChange = (event, maskValue, field) => {
        paymentInfo[field] = maskValue ? event : event.target.value;
        if (field === 'amount') setEditAmt(true);
    }

    const handleAmountChange = (e) => {
        const val = e.target.value;
        if (isNaN(val)) {
            amounts.base = 0;
            amounts.fee = 0;
            amounts.total = 0;
            setEditAmt(false);
        } else {
            const amt = parseFloat(val);
            if (amt > 0) {
                amounts.base = amt;
                getProcessingFee(amt);
            } else {
                amounts.base = 0;
                amounts.fee = 0;
                amounts.total = 0;
                setEditAmt(false);
            }
        }
    }

    useEffect(() => {
        if (clearValues) {
            reset({
                firstName: null,
                middleName: null,
                lastName: null,
                suffix: null,
                partyId: null,
                amount: '',
                license: null,
                licenseState: '',
                address: null,
                city: null,
                state: '',
                zip: '',
                phone: '',
                email: null,
                posterReference: null
            });
        }
    }, [clearValues]);

    return (
        (<Paper elevation={3} sx={classes.controlPanel}>
            <Typography variant='h6' component='h2' color='primary' sx={{marginBottom: '.5rem'}}>Enter Party and Payment Information</Typography>
            <Grid2 container spacing={1} alignItems='top'>
                <Grid2
                    size={{
                        xs: 12,
                        lg: 6,
                        xl: 4
                    }}>
                    <FormControl
                        required
                        fullWidth
                        {...register('firstName')}
                    >
                        <FormLabel shrink={true} htmlFor='firstName' required sx={classes.inputLabel}>First Name</FormLabel>
                        <TextField
                            name="firstName"
                            variant='outlined'
                            fullWidth
                            onChange={(e) => handleChange(e, false, 'firstName')}
                            slotProps={{
                                htmlInput: {id: 'firstName', maxLength: 100, sx: classes.textbox }
                            }}
                        />
                    </FormControl>
                </Grid2>
                <Grid2
                    size={{
                        xs: 12,
                        lg: 6,
                        xl: 4
                    }}>
                    <FormControl
                        fullWidth
                        {...register('middleName')}
                    >
                        <FormLabel shrink={true} htmlFor='middleName' sx={classes.inputLabel}>Middle Name</FormLabel>
                        <TextField
                            name="middleName"
                            variant='outlined'
                            fullWidth
                            onChange={(e) => handleChange(e, false, 'middleName')}
                            slotProps={{
                                htmlInput: {id: 'middleName', maxLength: 100, sx: classes.textbox }
                            }}
                        />
                    </FormControl>
                </Grid2>
                <Grid2
                    size={{
                        xs: 12,
                        lg: 6,
                        xl: 4
                    }}>
                    <FormControl
                        required
                        fullWidth
                        {...register('lastName')}
                    >
                        <FormLabel shrink={true} htmlFor='lastName' required sx={classes.inputLabel}>Last Name</FormLabel>
                        <TextField
                            name="lastName"
                            variant='outlined'
                            fullWidth
                            onChange={(e) => handleChange(e, false, 'lastName')}
                            slotProps={{
                                htmlInput: {id: 'lastName', maxLength: 100, sx: classes.textbox }
                            }}
                        />
                    </FormControl>
                </Grid2>
                <Grid2
                    size={{
                        xs: 12,
                        lg: 6,
                        xl: 4
                    }}>
                    <FormControl
                        fullWidth
                        {...register('suffix')}
                    >
                        <FormLabel shrink={true} htmlFor='suffix' sx={classes.inputLabel}>Suffix</FormLabel>
                        <TextField
                            name="suffix"
                            variant='outlined'
                            fullWidth
                            onChange={(e) => handleChange(e, false, 'suffix')}
                            slotProps={{
                                htmlInput: {id: 'suffix', maxLength: 100, sx: classes.textbox }
                            }}
                        />
                    </FormControl>
                </Grid2>
                <Grid2
                    size={{
                        xs: 12,
                        lg: 3,
                        xl: 2
                    }}>
                    <FormControl
                        fullWidth
                        {...register('partyId')}
                    >
                        <FormLabel shrink={true} htmlFor='partyId' sx={classes.inputLabel}>Party Number</FormLabel>
                        <TextField
                            name="partyId"
                            variant='outlined'
                            type='number'
                            fullWidth
                            onChange={(e) => handleChange(e, false, 'partyId')}
                            slotProps={{
                                htmlInput: {id: 'partyId', maxLength: 100, sx: classes.textbox }
                            }}
                            sx={{
                                "& input::-webkit-outer-spin-button, & input::-webkit-inner-spin-button": {
                                    "-webkit-appearance": "none",
                                    margin: 0
                                },
                                "& input": {
                                    "-moz-appearance": "textfield"
                                }
                            }}
                        />
                    </FormControl>
                </Grid2>
                <Grid2
                    size={{
                        xs: 12,
                        lg: 3,
                        xl: 2
                    }}>
                    <FormControl
                        fullWidth
                        {...register('amount')}
                    >
                        <FormLabel shrink={true} htmlFor='amount' required sx={classes.inputLabel}>Payment Amt.</FormLabel>
                        <NumericFormat
                            id='amount'
                            name='amount'
                            customInput={TextField}
                            inputProps={{sx: classes.textbox}}
                            type='text'
                            autoComplete='off'
                            variant='outlined'
                            decimalScale={2}
                            decimalSeparator='.'
                            fixedDecimalScale={true}
                            onValueChange={(values) => handleChange(values, true, 'amount')}
                            onBlur={handleAmountChange}
                        />
                    </FormControl>
                </Grid2>
                <Grid2
                    size={{
                        xs: 12,
                        lg: 3,
                        xl: 2
                    }}>
                    <FormControl
                        fullWidth
                    >
                        <FormLabel shrink={true} htmlFor='dob' sx={classes.inputLabel}>
                            DOB
                        </FormLabel>
                        <LocalizationProvider dateAdapter={AdapterDateFns}>
                            <DatePicker
                                name='dob'
                                disableOpenPicker={true}
                                disableMaskedInput={false}
                                format='MM/dd/yyyy'
                                value={paymentInfo.dob}
                                onChange={(newValue) => {
                                    handleChange(newValue, true, 'dob')
                                }}
                                slotProps={{
                                    textField: {
                                        id: 'dob',
                                        inputProps: {
                                            sx: classes.textbox
                                        }
                                    }
                                }}
                            />
                        </LocalizationProvider>
                    </FormControl>
                </Grid2>
                <Grid2
                    size={{
                        xs: 12,
                        lg: 3,
                        xl: 2
                    }}>
                    <FormControl
                        fullWidth
                        {...register('license')}
                    >
                        <FormLabel shrink={true} htmlFor='license' sx={classes.inputLabel}>Driver’s license</FormLabel>
                        <TextField
                            name="license"
                            variant='outlined'
                            fullWidth
                            onChange={(e) => handleChange(e, false, 'license')}
                            slotProps={{
                                htmlInput: {id: 'license', maxLength: 25, sx: classes.textbox }
                            }}
                        />
                    </FormControl>
                </Grid2>
                <Grid2
                    size={{
                        xs: 12,
                        lg: 3,
                        xl: 2
                    }}>
                    <FormControl
                        fullWidth
                        {...register('licenseState')}
                    >
                        <FormLabel shrink={true} htmlFor='licenseState' sx={classes.inputLabel}>License State</FormLabel>
                        <Select
                            name='licenseState'
                            id='licenseState'
                            native
                            variant='outlined'
                            fullWidth
                            sx={{height: '2rem'}}
                            onChange={(e) => handleChange(e, false, 'licenseState')}
                        >
                            <option key='none' value=''></option>
                            { statesLong.map((_state) => (
                                <option key={_state.key} value={_state.value}>{_state.value}</option>
                            ))}
                        </Select>
                    </FormControl>
                </Grid2>
                <Grid2
                    size={{
                        xs: 12,
                        lg: 6,
                        xl: 4
                    }}>
                    <FormControl
                        fullWidth
                        {...register('address')}
                    >
                        <FormLabel shrink={true} htmlFor='address' sx={classes.inputLabel}>Address</FormLabel>
                        <TextField
                            name="address"
                            variant='outlined'
                            fullWidth
                            onChange={(e) => handleChange(e, false, 'address')}
                            slotProps={{
                                htmlInput: {id: 'address', maxLength: 100, sx: classes.textbox}
                            }}
                        />
                    </FormControl>
                </Grid2>
                <Grid2
                    size={{
                        xs: 12,
                        lg: 6,
                        xl: 4
                    }}>
                    <FormControl
                        fullWidth
                        {...register('city')}
                    >
                        <FormLabel shrink={true} htmlFor='city' sx={classes.inputLabel}>City</FormLabel>
                        <TextField
                            name="city"
                            variant='outlined'
                            fullWidth
                            onChange={(e) => handleChange(e, false, 'city')}
                            slotProps={{
                                htmlInput: {id: 'city', maxLength: 100, sx: classes.textbox}
                            }}
                        />
                    </FormControl>
                </Grid2>
                <Grid2
                    size={{
                        xs: 12,
                        lg: 3,
                        xl: 2
                    }}>
                    <FormControl
                        fullWidth
                        {...register('state')}
                    >
                        <FormLabel shrink={true} htmlFor='state' sx={classes.inputLabel}>State</FormLabel>
                        <Select
                            name='state'
                            id='state'
                            native
                            variant='outlined'
                            fullWidth
                            sx={{height: '2rem'}}
                            onChange={(e) => handleChange(e, false, 'state')}
                        >
                            <option key='none' value=''></option>
                            { statesLong.map((_state) => (
                                <option key={_state.key} value={_state.value}>{_state.value}</option>
                            ))}
                        </Select>
                    </FormControl>
                </Grid2>
                <Grid2
                    size={{
                        xs: 12,
                        lg: 3,
                        xl: 2
                    }}>
                    <FormControl
                        fullWidth
                        {...register('zip')}
                    >
                        <FormLabel htmlFor={'zip'} shrink={true} sx={classes.inputLabel}>Zip</FormLabel>
                        <PatternFormat
                            name='zip'
                            customInput={TextField}
                            type='text'
                            autoComplete='off'
                            variant='outlined'
                            format="#####"
                            onValueChange={(values) => handleChange(values, true, 'zip')}
                            InputProps={{
                                style: classes.numberbox
                            }}
                            inputProps={{
                                id: 'zip'
                            }}
                        />
                    </FormControl>
                </Grid2>
                <Grid2
                    size={{
                        xs: 12,
                        lg: 6,
                        xl: 4
                    }}>
                    <FormControl
                        fullWidth
                        {...register('email')}
                    >
                        <FormLabel shrink={true} htmlFor='email' sx={classes.inputLabel}>Email</FormLabel>
                        <TextField
                            name="email"
                            variant='outlined'
                            fullWidth
                            onChange={(e) => handleChange(e, false, 'email')}
                            slotProps={{
                                htmlInput: {id: 'email', maxLength: 100, sx: classes.textbox}
                            }}
                        />
                    </FormControl>
                </Grid2>
                <Grid2
                    size={{
                        xs: 12,
                        lg: 3,
                        xl: 2
                    }}>
                    <FormControl
                        fullWidth
                        {...register('phone')}
                    >
                        <FormLabel shrink={true} htmlFor='phone' sx={classes.inputLabel}>Phone</FormLabel>
                        <PatternFormat
                            name='phone'
                            id='phone'
                            customInput={TextField}
                            type='text'
                            autoComplete='off'
                            variant='outlined'
                            format="(###) ###-####"
                            onValueChange={(values) => handleChange(values, true, 'phone')}
                            InputProps={{
                                style: classes.numberbox
                            }}
                        />
                    </FormControl>
                </Grid2>
                <Grid2
                    size={{
                        xs: 12,
                        lg: 3,
                        xl: 2
                    }}>
                    <FormControl fullWidth>
                        <FormLabel shrink={true} htmlFor='violationDate' sx={classes.inputLabel}>
                            Date Charged
                        </FormLabel>
                        <LocalizationProvider dateAdapter={AdapterDateFns}>
                            <DatePicker
                                name='violationDate'
                                disableOpenPicker={false}
                                disableMaskedInput={false}
                                format='MM/dd/yyyy'
                                value={paymentInfo.violationDate}
                                onChange={(newValue) => {
                                    handleChange(newValue, true, 'violationDate')
                                }}
                                slotProps={{
                                    textField: {
                                        inputProps: {
                                            id: 'violationDate',
                                            sx: classes.textbox
                                        }
                                    }
                                }}
                            />
                        </LocalizationProvider>
                    </FormControl>
                </Grid2>
                <Grid2 sx={{marginBottom: '1rem'}} size={12}>
                    <FormControl
                        fullWidth
                        {...register('posterReference')}
                    >
                        <FormLabel shrink={true} htmlFor='posterReference' sx={classes.inputLabel}>
                            Reference Information
                            <Typography component='span' sx={{fontSize: '.9rem'}}>
                                &nbsp;(Include relevant case and citation numbers)
                            </Typography>
                        </FormLabel>
                        <TextField
                            fullWidth
                            multiline
                            rows={4}
                            onChange={(e) => handleChange(e, false, 'posterReference')}
                            sx={{resize: 'none'}}
                            slotProps={{
                                htmlInput: {id: 'posterReference', maxLength: 4000}
                            }}
                        />
                    </FormControl>
                </Grid2>
            </Grid2>
        </Paper>)
    );
}

export default PaymentInfo;
